import type { CreditCardBrand } from '@contracts/payment/CreditCard';
import Amex from '@src/common/assets/creditCards/amex.svg?react';
import Mastercard from '@src/common/assets/creditCards/mastercard.svg?react';
import Visa from '@src/common/assets/creditCards/visa.svg?react';
import { useTranslation } from 'react-i18next';

export const CreditCardLogo = ({ brand }: { brand: CreditCardBrand }) => {
  const { t } = useTranslation();
  const props = { height: 25 };

  switch (brand.toUpperCase()) {
    case 'AMEX':
      return <Amex role="img" aria-label={t('creditCards.amex')} {...props} />;
    case 'MASTER_CARD':
      return (
        <Mastercard
          role="img"
          aria-label={t('creditCards.mastercard')}
          {...props}
        />
      );
    case 'VISA':
      return <Visa role="img" aria-label={t('creditCards.visa')} {...props} />;
  }
};
